export default __webpack_public_path__ + "static/media/prestashop.674384be.png";